import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-covid-safety-measures',
  templateUrl: './covid-safety-measures.component.html',
  styleUrls: ['./covid-safety-measures.component.less']
})
export class CovidSafetyMeasuresComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
